/* =========================================================
   ELECTRO HEAVEN — Mobile-first theme JS
   ========================================================= */
(function () {
  'use strict';

  var body = document.body;

  function open(el) { if (el) { el.classList.add('open'); el.setAttribute('aria-hidden', 'false'); body.style.overflow = 'hidden'; } }
  function close(el) { if (el) { el.classList.remove('open'); el.setAttribute('aria-hidden', 'true'); body.style.overflow = ''; } }

  var menu = document.getElementById('mobile-menu');
  var cart = document.getElementById('cart-drawer');
  var search = document.getElementById('search-modal');

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-menu],[data-close-menu],[data-open-cart],[data-close-cart],[data-open-search],[data-close-search]');
    if (!t) return;
    if (t.hasAttribute('data-open-menu'))    { open(menu); }
    if (t.hasAttribute('data-close-menu'))   { close(menu); }
    if (t.hasAttribute('data-open-cart'))    { e.preventDefault(); open(cart); }
    if (t.hasAttribute('data-close-cart'))   { close(cart); }
    if (t.hasAttribute('data-open-search'))  { open(search); var si = document.getElementById('search-input'); if (si) setTimeout(function () { si.focus(); }, 250); }
    if (t.hasAttribute('data-close-search')) { close(search); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(menu); close(cart); close(search); }
  });

  function fmt(cents) {
    return 'Rs. ' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function refreshCartUI(state) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = state.item_count;
      el.setAttribute('data-count', state.item_count);
    });
    var total = document.getElementById('cart-drawer-total');
    if (total) total.textContent = fmt(state.total_price);
    var foot = document.getElementById('cart-drawer-foot');
    if (foot) foot.hidden = state.item_count === 0;
  }

  function updateCart(id, quantity, added) {
    var payload = added ? { items: [{ id: id, quantity: quantity }] } : { id: id, quantity: quantity };
    var url = added ? '/cart/add.js' : '/cart/change.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (state) { refreshCartUI(state); rebuildDrawer(state); return state; });
  }

  function rebuildDrawer(state) {
    var container = document.getElementById('cart-drawer-body');
    if (!container) return;
    if (state.item_count === 0) {
      container.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--primary" data-close-cart>Start Shopping</a></div>';
      return;
    }
    var html = '';
    state.items.forEach(function (item) {
      html += '<div class="cart-item" data-key="' + item.key + '">' +
        '<img class="cart-item__img" src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_80x80$1$2') : '') + '" alt="" width="68" height="68" loading="lazy">' +
        '<div class="cart-item__info">' +
        '<p class="cart-item__name">' + item.product_title + '</p>' +
        (item.variant_title ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '') +
        '<p class="cart-item__price">' + fmt(item.final_price) + '</p>' +
        '<div class="cart-item__qty">' +
        '<button data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
        '</div></div>' +
        '<button class="cart-item__remove" data-key="' + item.key + '" data-qty="0" aria-label="Remove">✕</button>' +
        '</div>';
    });
    container.innerHTML = html;
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.js-add-to-cart');
    if (addBtn && addBtn.dataset.variantId) {
      e.preventDefault();
      var original = addBtn.innerHTML;
      addBtn.disabled = true;
      addBtn.innerHTML = 'Adding…';
      updateCart(addBtn.dataset.variantId, parseInt(addBtn.dataset.qty || '1', 10), true)
        .then(function () { addBtn.innerHTML = '✓ Added'; open(cart); setTimeout(function () { addBtn.innerHTML = original; addBtn.disabled = false; }, 1200); })
        .catch(function () { addBtn.innerHTML = original; addBtn.disabled = false; });
    }
    var qtyBtn = e.target.closest('.cart-item__qty button, .cart-item__remove');
    if (qtyBtn && qtyBtn.dataset.key) { updateCart(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.qty, 10), false); }
    var wish = e.target.closest('.js-wishlist');
    if (wish) { wish.classList.toggle('active'); }
  });

  var pdpForm = document.querySelector('[data-product-form]');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = pdpForm.querySelector('[name="id"]');
      var qtyInput = document.getElementById('pdp-qty') || pdpForm.querySelector('[name="quantity"]');
      var submit = pdpForm.querySelector('[type="submit"]');
      var original = submit ? submit.innerHTML : '';
      if (submit) { submit.disabled = true; submit.innerHTML = 'Adding…'; }
      updateCart(idInput.value, parseInt(qtyInput.value || '1', 10), true)
        .then(function () { if (submit) { submit.innerHTML = '✓ Added to Cart'; } open(cart); setTimeout(function () { if (submit) { submit.innerHTML = original; submit.disabled = false; } }, 1400); })
        .catch(function () { if (submit) { submit.innerHTML = original; submit.disabled = false; } });
    });
  }

  var qtyInput = document.getElementById('pdp-qty');
  if (qtyInput) {
    var dec = document.getElementById('pdp-qty-dec');
    var inc = document.getElementById('pdp-qty-inc');
    if (dec) dec.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });
  }

  var variantData = window.__variants;
  if (variantData) {
    var selected = {};
    document.querySelectorAll('.pdp__option').forEach(function (group) {
      var idx = group.dataset.optionIndex;
      var active = group.querySelector('.pdp__option-btn.active');
      if (active) selected[idx] = active.dataset.value;
    });
    document.querySelectorAll('.pdp__option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.pdp__option');
        group.querySelectorAll('.pdp__option-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selected[group.dataset.optionIndex] = btn.dataset.value;
        var match = variantData.find(function (v) {
          return v.options.every(function (opt, i) { return String(selected[i]) === String(opt); });
        });
        if (match) {
          var idField = document.querySelector('[data-product-form] [name="id"]');
          if (idField) idField.value = match.id;
          var priceEl = document.getElementById('pdp-price');
          if (priceEl) priceEl.textContent = fmt(match.price);
          var stickyPrice = document.getElementById('sticky-price');
          if (stickyPrice) stickyPrice.textContent = fmt(match.price);
        }
      });
    });
  }

  document.querySelectorAll('.pdp__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById('pdp-main-img');
      if (main && thumb.dataset.src) main.src = thumb.dataset.src;
      document.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  var descToggle = document.getElementById('pdp-desc-toggle');
  if (descToggle) {
    descToggle.addEventListener('click', function () {
      var b = document.getElementById('pdp-desc-body');
      var openNow = descToggle.getAttribute('aria-expanded') === 'true';
      if (b) b.style.display = openNow ? 'none' : 'block';
      descToggle.setAttribute('aria-expanded', String(!openNow));
    });
  }

  var stickyAtc = document.getElementById('sticky-atc');
  var mainAtc = document.getElementById('pdp-atc');
  if (stickyAtc && mainAtc) {
    var onScroll = function () { var r = mainAtc.getBoundingClientRect(); stickyAtc.classList.toggle('visible', r.bottom < 0); };
    window.addEventListener('scroll', onScroll, { passive: true });
    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { mainAtc.click(); });
  }

  document.querySelectorAll('.footer__acc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.innerWidth >= 900) return;
      var next = btn.nextElementSibling;
      if (next) next.classList.toggle('open');
    });
  });

})();
